import React, { useContext } from 'react'
import { useIntl } from 'react-intl'
import { DispatchStore, StateStore } from '../../containers/StoreProvider'
import { MenuContainer, MenuList } from '../layout'
import { MenuLink } from '../MenuLink'
import { OfflineIconContainer, OfflineMenuIcon } from '../OfflineMode'
import { showSocketModal } from '../../containers/StoreProvider/actions'
import { ThemeButton } from '../ThemeButton'
import { ApolloClient } from '@apollo/client'
import { TOWING_JOBS_SEARCH_QUERY } from '../../containers/TowingJobsPage/TowingJobsQuery'
import { TOWING_JOBS_OPEN_QUERY } from '../../containers/StoreProvider/queries'
import { countJobs } from '../../containers/StoreProvider/OpenJobCountWatcher'
import { useLocation } from 'react-router-dom'
import { useQuery } from '@apollo/client/react'
import { messages } from './messages'

export const NavigationMenu: React.FunctionComponent<any> = ({ client }: { client: ApolloClient }) => {
  const location = useLocation();
  const { formatMessage } = useIntl()
  const { state } = useContext(StateStore)
  const { dispatch } = useContext(DispatchStore)

  const { data } = useQuery(TOWING_JOBS_OPEN_QUERY, {
    notifyOnNetworkStatusChange: true,
  })

  const openJobsCount = countJobs(data?.towingOrders?.towingOrders || [])

  const openMessages = () => {
    dispatch(showSocketModal())
  }

  return (
    <>
      <OfflineIconContainer>
        {state.offlineMode && <OfflineMenuIcon offline={state.offlineMode} />}
      </OfflineIconContainer>
      <MenuContainer>
        <MenuList>
          <MenuLink
            onClick={() => {
              if(location.pathname === '/towing-jobs'){
                client.refetchQueries({ include: [TOWING_JOBS_SEARCH_QUERY] });
              }
            }}
            to="/towing-jobs"
            label={formatMessage(messages.jobs)}
            category="orders"
            exact
            count={openJobsCount}
          />
          <MenuLink to="/shifts" label={formatMessage(messages.shifts)} category="shifts" />
          <MenuLink to="" label={formatMessage(messages.messages)} category="messages" count={state.messageCount} onClick={openMessages} />
          <MenuLink to="/settings" label={formatMessage(messages.settings)} category="settings" />
          <ThemeButton />
        </MenuList>
      </MenuContainer>
    </>
  )
}
